<template>
    <div class="bg-gray-100 flex items-center p-3 md:p-4 rounded-md">

        <!-- VRM for electric vehicles -->
        <div
            v-if="vehicle.vrm && vehicle.fuel === 'ELECTRICITY'"
            class="bg-green-400 mr-4 text-black uppercase text-sm md:text-lg text-center font-bold vrm-box flex rounded-md overflow-hidden">
            <div class="bg-yellow-300 rounded-r-md flex items-center justify-center py-1 ml-4 md:ml-5 w-full">
                <span>
                    {{ formatVrm(vehicle.vrm) }}
                </span>
            </div>
        </div>

        <!-- VRM for non-electric vehicles -->
        <div
            v-else
            class="mr-4 px-2 md:px-4 py-1 rounded-md flex-shrink-0 bg-yellow-300 text-black uppercase text-sm md:text-lg text-center font-bold vrm-box">
            <span class="w-full">
                {{ formatVrm(vehicle.vrm) }}
            </span>
        </div>

        <div class="vehicle-description-width">
            <div class="vehicle-make-and-model block text-sm leading-5 font-medium text-gray-900">
                {{ vehicle.make + ' ' + vehicle.model }}
            </div>
            <div class="mt-1 text-sm leading-5 text-gray-600 items-center hidden md:flex">
                <div>
                    {{ vehicle.year }}
                </div>
                <span v-if="vehicle.fuel" class="mx-2 inline" aria-hidden="true" >
                    &middot;
                </span>
                <div>
                    {{ vehicle.fuel }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VehicleCard",
    props: {
        vehicle: {
            type: Object,
            default: null,
        },
    },
    methods: {
        formatVrm(vrm) {
            const matched = vrm.match(/(\d+)(\D*)$/);
            if(matched) {
                const lastNumberIndex = matched.index + matched[1].length - 1;
                return vrm.slice(0, lastNumberIndex + 1).replace(/ /g, '') + " " + vrm.slice(lastNumberIndex + 1).replace(/ /g, '');
            }
        }
    },
}

</script>

<style scoped>
.vrm-box {
    min-width: 106px;
    max-width: 135px;
    flex-grow: 1;
    text-align: center;
}
@media (max-width: 1024px) {
  .vehicle-description-width {
    max-width: 303px;
  }
}
</style>
